// extracted by mini-css-extract-plugin
module.exports = {"resultList":"Week_resultList__1EmNP"};